<template>
  <div class="rating-stars-root p-b b-bottom d-f ai-c m-t-lg">
    <p class="flex-1">{{ title }}</p>
    <div class="d-f g ai-c flex-1 jc-c" @mouseout="hoveringStar = 0">
      <span
        :class="{ pointer: !readonly }"
        class=""
        v-for="i in 5"
        :key="i"
        @mouseover="mouseOverAt(i)"
        @click.prevent="setRating(i)"
      >
        <IconBase :w="15" :h="15" view-box="0 0 15 15">
          <IconStarFill v-if="i <= (hoveringStar || value || 0)" />
          <IconStar v-else />
        </IconBase>
      </span>
    </div>
    <p class="flex-1">{{ (value || 0).toFixed(1) }}</p>
  </div>
</template>

<script>
import IconBase from "@/assets/icons/IconBase.vue";
import IconStar from "@/assets/icons/IconStar.vue";
import IconStarFill from "@/assets/icons/IconStarFill.vue";

export default {
  name: "RatingStars",
  components: { IconStarFill, IconStar, IconBase },
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      // value could be NaN
      type: Number,
      default: 0,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hoveringStar: 0,
    };
  },
  methods: {
    mouseOverAt(i) {
      if (this.readonly) return;
      this.hoveringStar = i;
    },
    setRating(i) {
      if (this.readonly) return;

      this.$emit("rated", this.value === i ? 0 : i);
    },
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";
@import "@/scss/_mixins.scss";

.rating-stars-root > p {
  &:first-child {
    width: 100px;
  }

  &:last-child {
    text-align: right;
    width: 30px;
  }
}
</style>
